import React from 'react';

const PDFViewer = ({ pdfUrl }) => {
  return (
    <div className="pdf-viewer">
      {/* <iframe
        title="PDF Viewer"
        src={`https://docs.google.com/viewer?url=${encodeURIComponent(pdfUrl)}&embedded=true`}
        frameBorder="0"
        width="100%"
        height="500px"
      /> */}
       <object
        data={pdfUrl}
        type="application/pdf"
        width="100%"
        height="500px"
      ></object>
    </div>
  );
};

export default PDFViewer;
